import { MemberSummary } from './member-summary';
import { TopUpAccountStatus } from './top-up-account-status';
import { Feature } from './feature';
import { UserUpdateDetailsResponse } from './user-update-details-response';

export interface UserDetails {
    memberSummary: MemberSummary;
    topUpAccountStatus: TopUpAccountStatus;
    features: Feature[];
    updateUserDetailsResponse: UserUpdateDetailsResponse;
}
